import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const ImageGridBase = styled.div`
  max-width: 1200px;
`;

export const Title = styled.h2`
  text-align: center;
`;

export const Grid = styled.div`
  display: grid;
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(132px, 1fr));
  ${theme.largerThan.sm} {
    grid-template-columns: repeat(auto-fit, minmax(206px, 1fr));
  }
`;
